import { useCallback } from 'react'

import { useSegment } from '../../../../../../../hooks'

const TRACKING_MAP = {
  1: { step: '1 - Confirm', submitButton: 'Confirm', cancelButton: 'Cancel', backButton: 'Back' },
  2: { step: '2 - Submit', submitButton: 'Submit', cancelButton: 'Cancel', backButton: 'Back' },
  3: { step: '3 - Success', submitButton: 'Close', backButton: 'Back' },
}

export const useTrackVatDeclarationsIntegrationFormEvent = () => {
  const { track } = useSegment()

  const trackEvent = useCallback(
    (stepIndex: number, buttonType: 'submitButton' | 'cancelButton' | 'backButton') => {
      const stepConfig = TRACKING_MAP[stepIndex as keyof typeof TRACKING_MAP]
      const buttonName = stepConfig?.[buttonType as keyof typeof stepConfig]

      if (stepConfig && buttonName) {
        track('xxx - Bookkeeping - VAT - Submit VAT NL', {
          step: stepConfig.step,
          button: buttonName,
        })
      }
    },
    [track],
  )

  return { trackEvent }
}
